import { render } from "./ArrowTopIcon.vue?vue&type=template&id=501d4d62"
import script from "./ArrowTopIcon.vue?vue&type=script&lang=js"
export * from "./ArrowTopIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/enwan/enwan-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__